import type { SVGProps } from 'react';
import { memo } from 'react';

import { SVG_STOROKE_SIZE } from '@/data/shared/constant';

import { IconSizeType } from '@/types/icon';

interface SvgIconProps extends SVGProps<SVGSVGElement> {
  size: IconSizeType;
}
const SvgIconSpeakerLowRoundFill = ({ size = 24, ...props }: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 24 24"
    className="svgr-icon-component"
    strokeWidth={SVG_STOROKE_SIZE[size]}
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M13 5.998a1 1 0 0 0-1.627-.78L6.315 9.286H4.001a1 1 0 0 0-1 1v4.288a1 1 0 0 0 1 1h2.372l5.085 3.27a1 1 0 0 0 1.541-.84V5.998Zm1.74 3.71a1 1 0 0 1 1.394-.235c.248.177.47.39.656.632 1.093 1.403.772 3.388-.647 4.421a1 1 0 0 1-1.177-1.617c.534-.389.623-1.093.245-1.576l-.007-.01a1.07 1.07 0 0 0-.23-.22 1 1 0 0 1-.235-1.394Z"
      clipRule="evenodd"
    />
  </svg>
);
const Memo = memo(SvgIconSpeakerLowRoundFill);
export default Memo;
